import * as React from 'react';
import { FlightStaticInfoFragment } from '@websky/graphql';
import { GdsSeatService, ServicesMap } from '../../../types';
import SeatInfo from '../SeatInfo/SeatInfo';

interface Props {
	seatService: GdsSeatService[];
	fullInfo?: boolean;
	hideImage?: boolean;
	amenities?: FlightStaticInfoFragment['amenities'];
	services?: ServicesMap;
	passengerId?: string;
	segmentId?: string;
	getSeatGroupKey?: (service: GdsSeatService) => string;
}

const defaultGetSeatGroupKey = (service: GdsSeatService) => service.comfort;

const SeatInfoGroup: React.FC<Props> = props => {
	const getSeatGroupKey = props.getSeatGroupKey ?? defaultGetSeatGroupKey;

	const groupedSeatsInfo = React.useMemo(() => {
		const seatsMap = new Map<string, GdsSeatService>();

		props.seatService.forEach(service => {
			const key = getSeatGroupKey(service);
			const existService = seatsMap.get(key);

			if (existService && (existService.price.amount > service.price.amount || !existService.serviceImage)) {
				seatsMap.set(key, {
					...existService,
					serviceImage: !existService.serviceImage ? service.serviceImage : existService.serviceImage,
					price: service.price.amount < existService.price.amount ? service.price : existService.price
				});
			} else if (!existService) {
				seatsMap.set(key, service);
			}
		});

		return [...seatsMap.values()];
	}, [props.seatService, getSeatGroupKey]);

	return (
		<>
			{groupedSeatsInfo.map(seat => (
				<SeatInfo
					seatService={seat}
					key={seat.id}
					amenities={props.amenities}
					fullInfo={props.fullInfo}
					hideImage={props.hideImage}
					services={props.services}
					passengerId={props.passengerId}
					segmentId={props.segmentId}
				/>
			))}
		</>
	);
};

export default SeatInfoGroup;
